//services
import { CAS } from "../../service/ChatConfig.Service";

const ChatDeliveryError = ({className}:{className: string}) => (
    <p className={className}>
        {CAS.localisationStrings.YourMessageCouldNotBeDelivered()}
    </p>
)

export default ChatDeliveryError